import React, { useRef, useEffect, useState } from "react";
import "../../styles/update/portfolio.css";
import supabase from "../../lib/supabase";
import { Link } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

export default function Portfolio({ setPortfolioRef }) {
  const [projects, setProjects] = useState([]);
  const { theme } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("mobile");
  const portfolioRef = useRef(null);

  useEffect(() => {
    getProjects();
  }, []);

  const getProjects = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from("projects")
        .select("id,title,type,description,link,media,created_at,tech_tags")
        .order("created_at", { ascending: false });
      if (error) throw error;
      setProjects(data || []);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (setPortfolioRef) setPortfolioRef(portfolioRef);
  }, [setPortfolioRef]);

  const normalize = (v = "") => v.toLowerCase().replaceAll(" ", "");
  const activeKey = normalize(activeTab);
  const filtered = projects.filter((p) => {
    const t = normalize(p.type);
    if (activeKey === "mobile") return t.includes("mobile");
    if (activeKey === "web") return t.includes("web");
    if (activeKey === "ml")
      return t.includes("ml") || t.includes("machine learning");
    if (activeKey === "iot") return t.includes("iot");
    return true;
  });

  const Card = ({ project }) => {
    const first =
      Array.isArray(project.media) && project.media.length > 0
        ? project.media[0]
        : null;
    const isImage = first?.contentType?.startsWith("image/");
    return (
      <div className="portfolio-card">
        <div className="thumb">
          {first ? (
            isImage ? (
              <img src={first.url} alt={project.title} />
            ) : (
              <video src={first.url} controls />
            )
          ) : (
            <div className="thumb-placeholder">No media</div>
          )}
        </div>
        <div className="meta">
          <Link rel="noopener noreferrer" target="_blank" to={project.link}>
            <h4>{project.title}</h4>
          </Link>

          <p className="type">{project.type}</p>
          <p className="desc">{project.description}</p>
        </div>
        <div className="flex flex-wrap gap-2 mt-2 m-2 ml-3">
          {project.tech_tags?.map((tag, index) => {
            // {theme == 'dark' ? : (
            let colorOptions = "";
            if (theme == "dark") {
              colorOptions = [
                "bg-blue-900/40 text-blue-300",
                "bg-emerald-900/40 text-emerald-300",
                "bg-yellow-900/40 text-yellow-300",
                "bg-cyan-900/40 text-cyan-300",
                "bg-purple-900/40 text-purple-300",
                "bg-pink-900/40 text-pink-300",
                "bg-orange-900/40 text-orange-300",
              ];
            } else {
              colorOptions = [
                "bg-blue-100 text-blue-700 border border-blue-300",
                "bg-emerald-100 text-emerald-700 border border-emerald-300",
                "bg-amber-100 text-amber-700 border border-amber-300",
                "bg-cyan-100 text-cyan-700 border border-cyan-300",
                "bg-violet-100 text-violet-700 border border-violet-300",
                "bg-pink-100 text-pink-700 border border-pink-300",
                "bg-orange-100 text-orange-700 border border-orange-300",
              ];
            }

            // ) }

            // pick color based on index — loops through if there are more tags
            const colorClass = colorOptions[index % colorOptions.length];

            return (
              <span
                key={index}
                className={`px-2 py-1 text-xs rounded-full ${colorClass}`}
              >
                {tag}
              </span>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="portfolio" ref={portfolioRef}>
      <h2 className="section-heading">PORTFOLIO</h2>
      <div className="portfolio-item">
        <div className="action-btn">
          <button
            className={activeTab == "mobile" ? "active" : ""}
            onClick={() => setActiveTab("mobile")}
          >
            Mobile App
          </button>
          <button
            className={activeTab == "web" ? "active" : ""}
            onClick={() => setActiveTab("web")}
          >
            Website
          </button>
          <button
            className={activeTab == "ML" ? "active" : ""}
            onClick={() => setActiveTab("ML")}
          >
            Machine Learning/AI
          </button>
          <button
            className={activeTab == "IOT" ? "active" : ""}
            onClick={() => setActiveTab("IOT")}
          >
            IOT
          </button>
        </div>
      </div>

      <div style={{ marginTop: 40 }}>
        {loading ? (
          <p style={{ opacity: 0.7 }}>Loading projects...</p>
        ) : filtered.length > 0 ? (
          <div className="portfolio-grid">
            {filtered.map((p) => (
              <Card key={p.id} project={p} />
            ))}
          </div>
        ) : (
          <p style={{ opacity: 0.7 }}>No projects found for this category.</p>
        )}
      </div>
      <button className="view-btn mt-5">View all</button>
    </div>
  );
}
